<template>
    <div class="main-form">
        <StepNumber
            stepNum="3"
            totalSteps="5"
        ></StepNumber>
        <div class="main-form_info">
            <InputRadioButtons
                :options="$store.state.inputOptionsVariables.si_no_2avivienda"
                :title="$store.state.newTexts.step_aval_2avivienda[0].title"
                :selected = "$store.state.prescoringData.dgh.avalista"
                :explanation="$store.state.newTexts.step_aval_2avivienda[0].explanation || ''"
                @valueChanged = "(value) => handleValueChanged('avalista',value)"
            ></InputRadioButtons>
            <div class="main-form_info" v-if="$store.state.prescoringData.dgh.avalista === true">
                <InputSelect
                    :options="$store.state.inputOptionsVariables.tipo_avalista"
                    placeholder = "Indica tu avalista"
                    :selected = "$store.state.prescoringData.dgh.avalista_tipo"
                    :title="$store.state.newTexts.step_aval_2avivienda[1].title"
                    :explanation="$store.state.newTexts.step_aval_2avivienda[1].explanation || ''"
                    @valueChanged = "(value) => handleValueChanged('avalista_tipo',value)"
                ></InputSelect>
                <InputSlider
                    :minValue = 0
                    :maxValue = 1000000
                    :step = 1000
                    :currentValue = "$store.state.prescoringData.dgh.avalista_valor_vivienda??0"
                    :title="$store.state.newTexts.step_aval_2avivienda[2].title"
                    @valueChanged = "(value) => handleValueChanged('avalista_valor_vivienda',value)"
                ></InputSlider>
                <InputRadioButtons
                    :options="$store.state.inputOptionsVariables.si_no"
                    :title="$store.state.newTexts.step_aval_2avivienda[3].title"
                    :selected = "$store.state.prescoringData.dgh.avalista_hipoteca"
                    :explanation="$store.state.newTexts.step_aval_2avivienda[3].explanation || ''"
                    @valueChanged = "(value) => handleValueChanged('avalista_hipoteca',value)"
                ></InputRadioButtons>
                <InputSlider
                    v-if="$store.state.prescoringData.dgh.avalista_hipoteca === true"
                    :minValue = 0
                    :maxValue = 1000000
                    :step = 1000
                    :currentValue = "$store.state.prescoringData.dgh.avalista_hipoteca_valor??0"
                    :title="$store.state.newTexts.step_aval_2avivienda[4].title"
                    @valueChanged = "(value) => handleValueChanged('avalista_hipoteca_valor',value)"
                ></InputSlider>
            </div>
        </div>
        <NavegationButtons 
            :nextStep = "nextStep"
            :nextStepButtonActive = "canContinue"
            nextStepButtonText = "Continuar"
            backStepButtonText = "Atrás"
        ></NavegationButtons>
    </div>
</template>

<script>
import StepNumber from '../common/StepNumber.vue'
import NavegationButtons from '../common/NavegationButtons.vue'
import InputRadioButtons from '../common/InputRadioButtons.vue'
import InputSelect from '../common/InputSelect.vue'
import InputSlider from '../common/InputSlider.vue'

export default {
    name: 'step_aval_2avivienda',
    components: {
        StepNumber,
        NavegationButtons,
        InputRadioButtons,
        InputSelect,
        InputSlider
    },
    computed: {
        nextStep(){
            if(this.$store.state.prescoringData.dgh.avalista === false)
                return 'aval_ko';
            return 'step_datos_titular';
        },
        canContinue(){
            const { avalista, avalista_tipo, avalista_valor_vivienda, avalista_hipoteca, avalista_hipoteca_valor } = this.$store.state.prescoringData.dgh;
            // Avalista NO
            if(avalista === false) return true;
            // Avalista SI
            else{
                return avalista_tipo != null && avalista_valor_vivienda != null 
                    && ( avalista_hipoteca === false || ( avalista_hipoteca === true && avalista_hipoteca_valor > 0));
            }
        }
    },
    methods: {
        handleValueChanged(field, value){
            if(field == 'avalista' && value === false) this.$store.commit('resetAvalista');
            if(field == 'avalista_hipoteca' && value === false) this.$store.commit('resetAvalistaHipotecaValor');
            this.$store.commit('updateDghField', { field, value });
        }
    }
}
</script>

